var InventoryDto = (function () {
    function InventoryDto(ats, backorderable, id, orderable, preorderable, stock_level) {
        if (ats === void 0) { ats = 0; }
        if (backorderable === void 0) { backorderable = false; }
        if (id === void 0) { id = ""; }
        if (orderable === void 0) { orderable = false; }
        if (preorderable === void 0) { preorderable = false; }
        if (stock_level === void 0) { stock_level = 0; }
        this.ats = ats;
        this.backorderable = backorderable;
        this.id = id;
        this.orderable = orderable;
        this.preorderable = preorderable;
        this.stock_level = stock_level;
    }
    InventoryDto.fromOcapi = function (ocapiInventory) {
        return new InventoryDto(ocapiInventory.ats, ocapiInventory.backorderable, ocapiInventory.id, ocapiInventory.orderable, ocapiInventory.preorderable, ocapiInventory.stock_level);
    };
    return InventoryDto;
}());
export { InventoryDto };
//# sourceMappingURL=InventoryDto.js.map